export default {
  'notAuth.title': 'You are not authorized!',
  'notAuth.toHome': 'Back to Home',
  'notAuth.desc':
    "You don't have permission to access this page. Please contact with your system administrator.",
};
